import { render, staticRenderFns } from "./ProductBrandDetail.vue?vue&type=template&id=70672ee8&"
import script from "./ProductBrandDetail.vue?vue&type=script&lang=js&"
export * from "./ProductBrandDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports